import React, { useEffect, useMemo, useState } from "react";
import DaterangePicker from "../../common/Daterangepicker";
import Citiescommondropdown from "../../common/Citiescommondropdown";
import { useSelector } from "react-redux";
import { Search } from "lucide-react";
import info from "../../assets/info.jpg";
import toast from "react-hot-toast";
import DashboardSkeleton from "../../common/DashboardSkeleton";
import { getFilteredWheelAlertItems } from "./wheelAlertFilters";

const Wheelalignmentdashboard = () => {
  const cities = useSelector((state) => state?.cities?.citiesData);
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(today.getMonth() - 1);
  const [selectionRange, setSelectionRange] = useState({
    startDate: oneMonthAgo,
    endDate: today,
    key: "selection",
  });
  const [wheelalertsData, setWheelAlertsData] = useState([]);
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  let token = localStorage.getItem("token");
  const [cityFilter, setCityFilter] = useState("1");
  const cityOptions = useMemo(() => {
    if (!cities) return [];
    return Object.entries(cities).map(([key, value]) => ({
      value: key,
      label: value,
    }));
  }, [cities]);

  const wheelOverviewData = {
    counts: [
      {
        title: "Total Alignment Done",
        value: wheelalertsData?.countDetails?.totalAlignmentDone || 0,
        class: "bg-blue-700",
      },
      {
        title: "Total Balancing Done",
        value: wheelalertsData?.countDetails?.totalBalancingDone || 0,
        class: "bg-yellow-700",
      },
      {
        title: "Total Alignment Due",
        value: wheelalertsData?.countDetails?.totalAlingmentDue || 0,
        class: "bg-red-700",
      },
      {
        title: "Total Balancing Due",
        value: wheelalertsData?.countDetails?.totalBalancingDue || 0,
        class: "bg-orange-700",
      },      
    ], 
    countsTwo: [      
      {
        title: "Total Cost to Company",
        value: wheelalertsData?.countDetails?.totalCostToCompany || 0,
        class: "bg-green-700",
      },
      
      // {
      //   title: "Amount",
      //   value: wheelalertsData?.countDetails?.totalAmount || 0,
      //   class: "bg-green-700",
      // },
      {
        title: "Payment Completed",
        value: wheelalertsData?.countDetails?.totalPaymentCompleted || 0,
        class: "bg-blue-700",
      },
      {
        title: "Payment Pending",
        value: wheelalertsData?.countDetails?.totalPaymentPending || 0,
        class: "bg-orange-700",
      },
      {
        title: "Critical Counts",
        value: wheelalertsData?.countDetails?.criticalCount || 0,
        class: "bg-red-700",
      },
      {
        title: "Medium Count",
        value: wheelalertsData?.countDetails?.mediumCount || 0,
        class: "bg-blue-700",
      },
      {
        title: "Low Count",
        value: wheelalertsData?.countDetails?.lowCount || 0,
        class: "bg-green-700",
      },
    ],
  };

  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [statusFilter, setStatusFilter] = useState("All");
  const [vehicleSearch, setVehicleSearch] = useState("");
  const rowsPerPage = 10;

  const filteredWheelAlertItems = useMemo(() => {
    return getFilteredWheelAlertItems(
      wheelalertsData?.overallList || [],
      statusFilter,
      vehicleSearch,
    );
  }, [wheelalertsData?.overallList, statusFilter, vehicleSearch]);

  const totalPages = Math.max(
    1,
    Math.ceil((filteredWheelAlertItems?.length || 0) / rowsPerPage),
  );
  const startIndex = (currentPage - 1) * rowsPerPage;
  const paginatedVehicles = filteredWheelAlertItems?.slice(
    startIndex,
    startIndex + rowsPerPage,
  );

  const getWheelDataList = async () => {
    if (!token) {
      return toast.error("Session Expired Close all the tab and signin again");
    }
    // const formattedStartDate = formatDateForApi(
    //   selectionRange?.startDate,
    //   "start",
    // );
    // const formattedEndDate = formatDateForApi(selectionRange?.endDate, "end");
    setLoading(true);
    let query = "";
    if (cityFilter && cityFilter !== "All Cities") {
      query += `&cityId=${cityFilter}`;
    }
    // ?startDate=${formattedStartDate}&endDate=${formattedEndDate}${query}
    try {
      const response = await fetch(
        `${apiUrl}/api/dashboardreports/wheel-alignments-dashboard?${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        setWheelAlertsData(data?.dataValues);
        setCurrentPage(1);
      } else {
        setLoading(false);
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return;
      setLoading(false);
      console.error("Error fetching Hub Names:", error);
    }
  };

  useEffect(() => {
    getWheelDataList();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [statusFilter, vehicleSearch]);

  return (
    <>
      {loading ? (
        <div className="w-full">
          <DashboardSkeleton />
        </div>
      ) : (
        <div className="w-full">
          <div className="w-full relative">
            <div className="my-4 w-full">
              <div className="flex gap-4 p-4 justify-between">
                <h1 className="text-gray-900 text-2xl font-bold tracking-tight">
                  Wheel Alerts
                </h1>

                <div className="flex gap-4">
                  {" "}
                  {/* <DaterangePicker
                    selectionRange={selectionRange}
                    setSelectionRange={setSelectionRange}
                    style={-10}
                  /> */}
                  <div className="flex flex-wrap items-center gap-3 w-full md:w-auto">
                    <div className="min-w-[180px] px-3 py-2 bg-white rounded-[10px] shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10)] shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 inline-flex justify-start items-center gap-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        className="flex-shrink-0 w-4 h-4"
                      >
                        <path
                          d="M8.4005 14.5327C9.6405 13.462 13.3332 9.99534 13.3332 6.66668C13.3332 5.25219 12.7713 3.89563 11.7711 2.89544C10.7709 1.89525 9.41433 1.33334 7.99984 1.33334C6.58535 1.33334 5.2288 1.89525 4.2286 2.89544C3.22841 3.89563 2.6665 5.25219 2.6665 6.66668C2.6665 9.99534 6.35917 13.462 7.59917 14.5327C7.71469 14.6195 7.85531 14.6665 7.99984 14.6665C8.14437 14.6665 8.28499 14.6195 8.4005 14.5327Z"
                          stroke="#99A1AF"
                          strokeWidth="1.33333"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M8 8.66666C9.10457 8.66666 10 7.77123 10 6.66666C10 5.56209 9.10457 4.66666 8 4.66666C6.89543 4.66666 6 5.56209 6 6.66666C6 7.77123 6.89543 8.66666 8 8.66666Z"
                          stroke="#99A1AF"
                          strokeWidth="1.33333"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>

                      <Citiescommondropdown
                        value={cityFilter}
                        onChange={setCityFilter}
                        options={[
                          { value: null, label: "All Cities" },
                          ...cityOptions,
                        ]}
                        placeholder="City"
                        className="flex-1 min-w-[80px]"
                        showSearch={true}
                      />
                    </div>
                  </div>
                  <button
                    onClick={() => {
                      getWheelDataList();
                    }}
                    className="flex items-center gap-2 px-5 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-all duration-300 shadow-md hover:shadow-lg"
                  >
                    <Search size={18} />
                    Search
                  </button>
                </div>
              </div>
            </div>
            <div className="w-full px-8 pb-8 flex flex-col justify-start items-start gap-6 overflow-visible">
              <div className="self-stretch flex flex-wrap justify-start items-start gap-5">
                {wheelOverviewData &&
                  wheelOverviewData.counts.map((data, index) => (
                    <div className="flex-1 h-32 p-5 relative bg-white rounded-bl-xl rounded-br-xl shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-slate-200 inline-flex flex-col justify-start items-start gap-4">
                      <div
                        className={`w-28 h-2 left-[10px] top-0 absolute rounded-bl-lg rounded-br-lg ${data?.class}`}
                      />
                      <div className="self-stretch justify-start text-slate-500 text-xs font-semibold font-['Inter'] uppercase">
                        {data?.title}
                      </div>
                      <div className="self-stretch flex flex-col justify-start items-start gap-1">
                        <div className="self-stretch justify-start text-slate-900 text-3xl font-bold font-['Inter']">
                          {data?.value}
                        </div>
                        <div className="self-stretch justify-start text-slate-400 text-sm font-normal font-['Inter']">
                          {" "}
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
              <div className="self-stretch flex flex-wrap justify-start items-start gap-2.5">
                {wheelOverviewData &&
                  wheelOverviewData.countsTwo?.map((data, index) => (
                    <div className="flex-1 p-4 relative bg-white rounded-2xl border-l border-r border-t-[1.60px] border-b border-slate-200 inline-flex flex-col justify-start items-start gap-2 overflow-hidden">
                      <div
                        className={`w-64 h-1 left-0 top-0 absolute ${data?.class}`}
                      />
                      <div className="self-stretch justify-start text-slate-500 text-[10px] font-semibold font-['Inter'] tracking-wide">
                        {data?.title}
                      </div>
                      <div className="self-stretch justify-start text-slate-900 text-xl font-bold font-['Inter']">
                        {data?.value}
                      </div>
                      {/* <div className="self-stretch justify-start text-slate-400 text-xs font-normal font-['Inter']">
              Total T&amp;P jobs
            </div> */}
                    </div>
                  ))}
              </div>
              <div className="self-stretch p-4 bg-amber-100 rounded-xl outline outline-1 outline-offset-[-1px] outline-amber-200 inline-flex justify-start items-start gap-2">
                <div className="size-5 relative overflow-hidden">
                  <img src={info} alt="Info" />
                </div>
                <div className="justify-start text-amber-800 text-sm font-bold font-['Inter'] leading-5">
                  Policy: Wheel Alignment every 5,000 km |
                </div>
                <div className="flex-1 justify-start text-amber-800 text-sm font-bold font-['Inter'] leading-5">
                  Wheel Balancing every 10,000 km.
                </div>
              </div>
              <div className="self-stretch w-full overflow-x-auto">
                <div className=" w-full bg-white rounded-xl border border-gray-200 flex flex-col overflow-hidden">
                  {/* Header */}
                  <div className="px-6 pt-5 pb-4 flex flex-col gap-3 md:flex-row md:justify-between md:items-center">
                    <div className="text-gray-900 text-xs font-bold uppercase tracking-wide">
                      Wheel Maintenance Tracker
                    </div>

                    <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
                      <label className="flex items-center gap-2 rounded-md border border-gray-200 bg-white px-3 py-2 shadow-sm">
                        <Search size={14} className="text-gray-400" />
                        <input
                          type="text"
                          value={vehicleSearch}
                          onChange={(event) =>
                            setVehicleSearch(event.target.value)
                          }
                          placeholder="Search vehicle no"
                          className="w-40 border-none bg-transparent text-sm text-gray-700 outline-none placeholder:text-gray-400"
                        />
                      </label>

                      <div className="flex items-center gap-2 p-1 rounded-md border border-gray-200">
                        {["All", 
                        // "Alignment Due", "Balancing Due"
                      ].map(
                          (tab) => {
                            const isActive = statusFilter === tab;
                            return (
                              <button
                                key={tab}
                                onClick={() => setStatusFilter(tab)}
                                className={`px-3 py-[5px] rounded-md text-[10px] font-semibold uppercase tracking-wide transition-colors ${
                                  isActive
                                    ? "bg-blue-500 text-white"
                                    : "text-zinc-500 hover:bg-gray-100"
                                }`}
                              >
                                {tab}
                              </button>
                            );
                          },
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Table Header */}
                  <div className="grid grid-cols-[1.2fr_1fr_1.2fr_1.2fr_1.2fr_1fr_1.2fr_1.4fr] gap-4 px-6 py-3 bg-gray-50 border-y border-gray-200">
                    <div className="text-[10px] font-semibold uppercase tracking-wide text-gray-500">
                      Vehicle
                    </div>

                    <div className="text-[10px] font-semibold uppercase tracking-wide text-gray-500">
                      City
                    </div>                

                    <div className="text-right text-[10px] font-semibold uppercase tracking-wide text-gray-500">
                      KM Since Last Alignment
                    </div>

                    <div className="text-right text-[10px] font-semibold uppercase tracking-wide text-gray-500">
                      Next Alignment Due KM
                    </div>

                    <div className="text-right text-[10px] font-semibold uppercase tracking-wide text-gray-500">
                      Next Balancing KM
                    </div>

                    <div className="text-center text-[10px] font-semibold uppercase tracking-wide text-gray-500">
                      Severity Status
                    </div>

                    <div className="text-right text-[10px] font-semibold uppercase tracking-wide text-gray-500">
                      Last Service Details
                    </div>

                    <div className="text-center text-[10px] font-semibold uppercase tracking-wide text-gray-500">
                      Status
                    </div>
                  </div>

                  {/* Table Body */}
                  <div className="flex flex-col overflow-y-auto">
                    {paginatedVehicles?.length > 0 ? (
                      paginatedVehicles.map((data, index) => (
                        <div
                          key={`${data?.licensePlate || index}-${index}`}
                          className="grid grid-cols-[1.2fr_1fr_1.2fr_1.2fr_1.2fr_1fr_1.2fr_1.4fr] gap-4 px-6 py-4 items-center border-b border-gray-200 hover:bg-gray-50 transition-colors"
                        >
                          {/* Vehicle */}
                          <div className="min-w-0">
                            <div className="text-xs font-semibold text-gray-900 truncate">
                              {data?.name || "-"}
                            </div>

                            <div className="text-[11px] text-gray-500 truncate">
                              {data?.licensePlate || "-"}
                            </div>
                          </div>

                          {/* City */}
                          <div className="text-xs text-gray-700">
                            {data?.cityText || "-"}
                          </div>                          

                          {/* KM Since Service */}
                          <div className="text-xs text-right text-gray-900">
                            {data?.kmSinceLastAlignment || "0"} km
                          </div>

                          {/* Next Alignment */}
                          <div className="text-xs text-right text-gray-900">
                            {data?.nextAlignmentDue || "0"} km
                          </div>

                          {/* Next Balancing */}
                          <div className="text-xs text-right text-gray-900">
                            {data?.nextBalancingDue || "0"} km
                          </div>

                          {/* Severity */}
                          <div className="flex justify-center">
                            <span
                              className={`px-3 py-1 rounded-full text-[10px] font-semibold uppercase text-white ${
                                data?.severity === "CRITICAL"
                                  ? "bg-red-600"
                                  : data?.severity === "WARNING"
                                    ? "bg-yellow-500"
                                    : "bg-green-600"
                              }`}
                            >
                              {data?.severity || "-"}
                            </span>
                          </div>

                          {/* Last Service Details */}
                          <div className="text-[11px] text-right text-gray-900 space-y-1">
                            <div>
                              <span className="font-semibold">Odo:</span>{" "}
                              {data?.latestWheelAlignment?.ododmeterReading
                                ? `${data?.latestWheelAlignment?.ododmeterReading} km`
                                : "0"}
                            </div>
                            <div>
                              <span className="font-semibold">Service Date:</span>{" "}
                              {data?.latestWheelAlignment?.serviceDate
                                ? new Date(data?.latestWheelAlignment?.serviceDate).toLocaleDateString()
                                : "-"}
                            </div>
                            <div>
                              <span className="font-semibold">Payment Pending:</span>{" "}
                              {data?.latestWheelAlignment?.isPaymentPending ? "Yes" : "No"}
                            </div>
                            <div>
                              <span className="font-semibold">Rotated:</span>{" "}
                              {data?.latestWheelAlignment?.isRotated ? "Yes" : "No"}
                            </div>
                            <div>
                              <span className="font-semibold">Alignment:</span>{" "}
                              {data?.latestWheelAlignment?.isAlignmentDone ? "Yes" : "No"}
                            </div>
                            <div>
                              <span className="font-semibold">Balancing:</span>{" "}
                              {data?.latestWheelAlignment?.isBalancingDone ? "Yes" : "No"}
                            </div>
                            <div>
                              <span className="font-semibold">Cost To Company:</span>{" "}
                              {data?.latestWheelAlignment?.costToCompany ? "Yes" : "No"}
                            </div>
                          </div>

                          {/* Status */}
                          <div className="flex justify-center">
                            <span
                              className={`px-3 py-1 rounded-full text-[10px] font-semibold uppercase text-white ${
                                data?.severity === "OVERDUE"
                                  ? "bg-red-800"
                                  : data?.severity === "LOW"
                                    ? "bg-green-800"
                                    : data?.severity === "CRITICAL"
                                      ? "bg-red-800"
                                      : "bg-orange-800"
                              }`}
                            >
                              {data?.statusMessage || "-"}
                            </span>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="py-10 text-center text-gray-500 text-sm">
                        No Data Found
                      </div>
                    )}
                  </div>

                  <div className="flex items-center justify-between px-6 py-4 border-t border-gray-200 bg-gray-50">
                    <div className="text-sm text-gray-500">
                      Showing{" "}
                      {Math.min(
                        startIndex + 1,
                        filteredWheelAlertItems?.length || 0,
                      )}{" "}
                      -{" "}
                      {Math.min(
                        startIndex + rowsPerPage,
                        filteredWheelAlertItems?.length || 0,
                      )}{" "}
                      of {filteredWheelAlertItems?.length || 0}
                    </div>

                    <div className="flex items-center gap-2">
                      <button
                        onClick={() =>
                          setCurrentPage((prev) => Math.max(1, prev - 1))
                        }
                        disabled={currentPage === 1}
                        className="px-3 py-1.5 border border-gray-300 rounded-md text-sm text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        Prev
                      </button>

                      <span className="text-sm text-gray-600">
                        Page {currentPage} of {totalPages}
                      </span>

                      <button
                        onClick={() =>
                          setCurrentPage((prev) =>
                            Math.min(totalPages, prev + 1),
                          )
                        }
                        disabled={currentPage === totalPages}
                        className="px-3 py-1.5 border border-gray-300 rounded-md text-sm text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Wheelalignmentdashboard;
